import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

/**
 * # deliveryTimePrevious
 * This is to store the orginal time the user has chosen.
 *
 * This value is used in the ConfirmChangesModal to let the user know of
 * What they changed and what items will be removed resulting from
 * the validateFutureMenuItems thunk which is caused by them changing
 * that time.
 */
const slice = createSlice({
  name: '$deliveryTimePrevious',
  initialState,
  reducers: {
    setDeliveryTimePrevious(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, () => {
      return initialState;
    });
  },
});

export const { setDeliveryTimePrevious } = slice.actions;
export default slice.reducer;
